import React from 'react';
import styles from './guidance.module.scss';
import { IconEyeware, IconLighter, IconNoHeadwear } from '@yoti/ui-kit-components-react/globals';
import { ConfigSection } from '@components/config/ConfigSection';

const Guidance: React.FC = () => {
    return (
        <ConfigSection className={styles['guidance__title']} title="Remember to:">
            <div className={styles['guidance']}>
                <div className={styles['guidance__element']}>
                    <IconLighter className={styles['guidance__element__icon']} />
                    <div>Find a light area</div>
                </div>
                <div className={styles['guidance__element']}>
                    <IconNoHeadwear className={styles['guidance__element__icon']} />
                    <span>Remove any headwear</span>
                </div>
                <div className={styles['guidance__element']}>
                    <IconEyeware className={styles['guidance__element__icon']} />
                    <span>Keep your glasses on</span>
                </div>
            </div>
        </ConfigSection>
    );
};

export default Guidance;
